import { combineReducers } from 'redux';
import authReducer from './auth';
import arbitratorReducer from './arbitrator';
import verifyReducer from './verify';
import uploadDocsReducer from './uploadDocs';
import caseInformationReducer from './caseInformation';
import userInformationReducer from './userInformation';
import onBoardingReducer from './onBoarding';
import chatroomReducer from './chatroom';
import chatroomEnquirySettlement from './chatroomEnquirySettlement';
import arbiAgreement from './arbiAgreement';
import {i18nState} from "redux-i18n";

const rootReducer = combineReducers ({
    auth: authReducer,
    arbitrator: arbitratorReducer,
    verify: verifyReducer,
    uploadDocs: uploadDocsReducer,
    caseInfo: caseInformationReducer,
    userInfo: userInformationReducer,
    onBoarding: onBoardingReducer,
    chatroom: chatroomReducer,
    chatroomEnquirySettlement: chatroomEnquirySettlement,
    i18nState: i18nState,
    arbiAgreement: arbiAgreement
});

export default rootReducer;